module.exports = __webpack_public_path__ + "static/media/dan.fadea8a0.png";